
export const statusClasses = {
    "pendiente": "status-blue",
    "hora de arribo a carga": "status-orange",
    "liberacion de carga": "status-yellow",
    "arribo a descargar": "status-green",
    "liberacion de descarga": "status-light-green",
    "arribo a terminar vacio": "status-red",
    "salida de terminal": "status-grey"
  };
  
  export const statusNewNames = {
    "pendiente": "Creado",
    "hora de arribo a carga": "Cargado",
    "liberacion de carga": "Transito",
    "arribo a descargar": "En destino",
    "liberacion de descarga": "Transito vacio",
    "arribo a terminar vacio": "En puerta vacio",
    "salida de terminal": "Finalizado"
  };
  